import { MessageCircle } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import saviaLogo from '../../assets/logo_blanco.png';
import { EMAIL, WHATSAPP_URL, PHONE_MAIN, PHONE_ALT } from '../../data/contact';

const linkClass = 'hover:text-accent transition-colors';

const Footer = () => {
  const { t } = useLang();

  return (
    <footer className="relative bg-dark text-white/80">
      {/* Wave SVG */}
      <div className="absolute -top-px left-0 right-0 overflow-hidden" aria-hidden="true">
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path
            d="M0 60L60 50C120 40 240 20 360 15C480 10 600 20 720 25C840 30 960 30 1080 25C1200 20 1320 10 1380 5L1440 0V60H0Z"
            fill="#0D1F15"
          />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-20 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Column 1: Logo */}
          <div>
            <div className="mb-4">
              <img
                src={saviaLogo}
                alt="SAVIA Sustainability Advisors"
                width="480"
                height="231"
                loading="lazy"
                className="h-12 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-sm text-white/70 leading-relaxed">
              {t.footer.description}
            </p>
          </div>

          {/* Column 2: Services */}
          <div>
            <h2 className="font-body text-white font-semibold mb-4">{t.footer.servicesTitle}</h2>
            <ul className="space-y-3 text-sm">
              {t.footer.services.map((service) => (
                <li key={service}>
                  <a href="#servicios" className={linkClass}>{service}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Company */}
          <div>
            <h2 className="font-body text-white font-semibold mb-4">{t.footer.companyTitle}</h2>
            <ul className="space-y-3 text-sm">
              {[
                { label: t.footer.aboutUs, to: 'quienes-somos' },
                { label: t.footer.ourProjects, to: 'proyectos' },
                { label: t.footer.ourTeam, to: 'equipo' },
              ].map(({ label, to }) => (
                <li key={to}>
                  <a href={`#${to}`} className={linkClass}>{label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div>
            <h2 className="font-body text-white font-semibold mb-4">{t.footer.contactTitle}</h2>
            <ul className="space-y-3 text-sm">
              <li><a href={`mailto:${EMAIL}`} className={linkClass}>{EMAIL}</a></li>
              <li>
                (506){' '}
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className={linkClass}>{PHONE_MAIN}</a>
                {' / '}
                <a href={PHONE_ALT.href} className={linkClass}>{PHONE_ALT.label}</a>
              </li>
              <li>{t.contact.info.location}</li>
            </ul>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-4 px-5 py-2.5 bg-accent/20 text-accent rounded-full text-sm font-medium hover:bg-accent/30 transition-colors"
            >
              <MessageCircle size={16} aria-hidden="true" />
              {t.footer.whatsapp}
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-3 text-center md:text-left text-xs text-white/60">
          <p>&copy; {new Date().getFullYear()} SAVIA Sustainability Advisors. {t.footer.rights}</p>
          <p>
            {t.footer.developedBy}{' '}
            <a
              href="https://www.tytsoftware.com/?utm_source=saviasacr.com&utm_medium=referral&utm_campaign=credito-sitio"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/80 font-medium hover:text-accent transition-colors"
            >
              TyT Software
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
